export default "__VITE_ASSET__BHsm$mK6__"